import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { Text } from "@/components/typography";
import styles from "./ui.module.css";

export interface LoadingStateProps {
  message?: ReactNode;
  className?: string;
}

export function LoadingState({
  message = "Loading…",
  className,
}: LoadingStateProps) {
  return (
    <div className={cn(styles.loading, className)} role="status" aria-live="polite">
      <span className={styles.spinner} aria-hidden />
      <Text role="body" color="secondary" as="span">
        {message}
      </Text>
    </div>
  );
}
